// extracted by mini-css-extract-plugin
export var bounce = "_p3-1";
export var generatingText = "_p3-6";
export var lightning = "_p3-4";
export var popup = "_p3-5";
export var progressBar = "_p3-7";
export var progressFill = "_p3-8";
export var progressShimmer = "_p3-9";
export var progressText = "_p3-a";
export var shimmer = "_p3-3";
export var uploadIcon = "_p3-0";
export var uploadingText = "_p3-2";